/**
 * MyAccountPage
 * @module pages/MyAccountPage
 */

import React, { useContext, useEffect, useState, useRef } from 'react';
import Layout from 'components/ui/Layout';
import {
	Wrapper,
	Table,
	Property,
	Value,
	Caption,
} from './MyAccountPage.styles';
import ContentArea from 'components/framework/ContentArea';
import Breadcrumbs from 'components/framework/Breadcrumbs';
import { LocalizationContext } from 'context/localization.context';
import SectionHeader from 'components/ui/SectionHeader';
import { useSelector } from 'react-redux';
import { selectUserObject } from 'store/modules/user';
import { fetchAccount } from 'api/myaccount';

const MyAccountPage = ({
	heading,
	breadcrumbs,
	text,
	columnList,
	isInEditMode,
	contentArea,
}) => {
	const { t } = useContext(LocalizationContext);
	const { customers } = useSelector(selectUserObject);
	const [accountColumns, setAccountColumns] = useState(columnList);

	const didRender = useRef(false);

	const fetchAccountColumns = async () => {
		try {
			if (window?.location?.href) {
				const data = await fetchAccount(window.location.href);
				setAccountColumns(data);
			}
		} catch (error) {
			console.error(error);
		}
	};
	useEffect(() => {
		if (didRender.current) {
			fetchAccountColumns();
		}
		if (!didRender.current && typeof customers !== 'undefined') {
			didRender.current = true;
		}
		//eslint-disable-next-line
	}, [customers]);

	return (
		<main id="main-content">
			<Layout>
				<Breadcrumbs links={breadcrumbs} />
			</Layout>
			<SectionHeader
				heading={heading}
				text={text}
				size="large"
				isInEditMode={isInEditMode}
				fullWidth={false}
			/>
			<Layout>
				<Wrapper>
					{accountColumns &&
						accountColumns.map((item, i) => (
							<Table as="table" key={i} className="rounded-lg">
								{item.heading && (
									<Caption as="caption" className="rounded-t-xl">
										{item.heading}
									</Caption>
								)}

								<thead className="sr-only">
									<tr>
										<th scope="col">
											{t('shared/specificationslist/property')}
										</th>
										<th scope="col">{t('shared/specificationslist/value')}</th>
									</tr>
								</thead>
								<tbody>
									{item &&
										item.dictionary &&
										Object.keys(item.dictionary).map((key, i) => {
											return (
												<React.Fragment key={i}>
													<tr className="odd:bg-white even:bg-beige text-2xl">
														<Property className="font-semibold">{key}</Property>
														<Value>{item.dictionary[key]}</Value>
													</tr>
												</React.Fragment>
											);
										})}
								</tbody>
							</Table>
						))}
				</Wrapper>
			</Layout>
			{contentArea && <ContentArea contentArea={contentArea} />}
		</main>
	);
};

export default MyAccountPage;
